import ApplicationController from "./application_controller";
import Cropper from "cropperjs";

export default class extends ApplicationController {
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    console.log("Rh Dashboard controller js en cours ..");
    
  }
}
